import {
  QUICK_FILL_TEMPLATE_CREATE,
  QUICK_FILL_TEMPLATE_CREATE_SUBMIT,
  QUICK_FILL_TEMPLATE_CREATE_FAILURE,
  QUICK_FILL_TEMPLATE_UPDATE,
  QUICK_FILL_TEMPLATE_UPDATE_SUBMIT,
  QUICK_FILL_TEMPLATE_UPDATE_FAILURE,
  QUICK_FILL_TEMPLATE_DELETE,
  QUICK_FILL_TEMPLATE_DELETE_SUBMIT,
  QUICK_FILL_TEMPLATE_DELETE_FAILURE,
  QUICK_FILL_TEMPLATE_SORT_SUBMIT,
  QUICK_FILL_TEMPLATE_SORT
} from './constants'

export const quickFillTemplateCreateSubmit = payload => ({ payload, type: QUICK_FILL_TEMPLATE_CREATE_SUBMIT })
export const quickFillTemplateCreate = payload => ({ payload, type: QUICK_FILL_TEMPLATE_CREATE })
export const quickFillTemplateCreateFailure = payload => ({ payload, type: QUICK_FILL_TEMPLATE_CREATE_FAILURE })

export const quickFillTemplateUpdateSubmit = payload => ({ payload, type: QUICK_FILL_TEMPLATE_UPDATE_SUBMIT })
export const quickFillTemplateUpdate = payload => ({ payload, type: QUICK_FILL_TEMPLATE_UPDATE })
export const quickFillTemplateUpdateFailure = payload => ({ payload, type: QUICK_FILL_TEMPLATE_UPDATE_FAILURE })

export const quickFillTemplateDeleteSubmit = payload => ({ payload, type: QUICK_FILL_TEMPLATE_DELETE_SUBMIT })
export const quickFillTemplateDelete = payload => ({ payload, type: QUICK_FILL_TEMPLATE_DELETE })
export const quickFillTemplateDeleteFailure = payload => ({ payload, type: QUICK_FILL_TEMPLATE_DELETE_FAILURE })

export const quickFillTemplateSortSubmit = payload => ({ payload, type: QUICK_FILL_TEMPLATE_SORT_SUBMIT })
export const quickFillTemplateSort = payload => ({ payload, type: QUICK_FILL_TEMPLATE_SORT })
